import React from "react"

function PasswordToggle(props) {
  return (
    <span
      {...props}
      className={
        "passtoggle mdi mdi-eye" +
        (props.className ? " " + props.className : "")
      }
    />
  )
}

export default PasswordToggle
